import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ExpandableCellService {
  public expandedGroups$ = new BehaviorSubject<Record<string, boolean>>({});

  public toggleGroup(group: string, open: boolean) {
    this.expandedGroups$.next({
      ...this.expandedGroups$.value,
      [group]: open,
    });
  }
}
